import Vue from 'vue'

const session = {
  namespaced: true,
  state: {
    session: null,
    daysLeft: {}
  },
  // CRUD / RESTful actions
  mutations: {
    SET(state, data) {
      state.session = data
    },
    SET_DAYS_LEFT(state, data) {
      state.daysLeft = {...data}
    }
  },
  actions: {
    async fetch({commit}) {
      const session = await Vue.prototype.$session.get('session')
      if(session){
        const response = await Vue.prototype.$axios.get('daysleft?client=' + session.id)
        commit('SET', session)
        commit('SET_DAYS_LEFT', response.data)
      }
    },
    async update({commit}, data) {
      Vue.prototype.$session.set('session', data)
      const session = await Vue.prototype.$session.get('session')
      if(session){
        const response = await Vue.prototype.$axios.get('daysleft?client=' + session.id)
        commit('SET', session)
        commit('SET_DAYS_LEFT', response.data)
      }
    }
  },
  getters: {
    clientName(state) {
      return state.session.name
    }
  }
}

export default session